import React from 'react'
import PropTypes from 'prop-types'
import * as S from './CatalogGoodContainer.styled'
import CatalogGoodItem from '../CatalogGoodItem/CatalogGoodItem'
import { useList, useStore } from 'effector-react'
import { $shipment } from '@entities/shipment/model'
import { useRouter } from 'next/router'
import { $goodsFiltered, useGoodsFilteredIsEmpty } from 'src/features/filter-goods/model/goods-result'
import { $isPendingGroup, $isPendingSearch } from 'src/features/goods-groups-update/model'
import { $isPendingSuggestion } from 'src/features/suggestions/model'
import { GoodItemSkeletonMobile } from 'src/shared/ui/skeleton/good-item-mobile/ui'

const CatalogGoodContainer = (props) => {
    const shipment = useStore($shipment)
    const goodsFilteredIsEmpty = useGoodsFilteredIsEmpty()
    const router = useRouter()
    const isLoadingSearch = useStore($isPendingSearch)
    const isLoadingGroup = useStore($isPendingGroup)
    const isLoadingSuggestions = useStore($isPendingSuggestion)
    const goods = useList($goodsFiltered, {
        // keys: [router.query],
        getKey: (good) => good.webData.goodId,
        fn: (good) => {
            return (
                <CatalogGoodItem
                    key={good.webData.goodId}
                    isDelivery={props.isDelivery}
                    shipment={shipment}
                    groupId={props.groupId}>
                    {good}
                </CatalogGoodItem>
            )
        }
    })
    if (isLoadingGroup || isLoadingSearch || isLoadingSuggestions) {
        return (
            <S.Container>
                <GoodItemSkeletonMobile />
                <GoodItemSkeletonMobile />
                <GoodItemSkeletonMobile />
                <GoodItemSkeletonMobile />
            </S.Container>
        )
    }

    return (
        <S.Container>
            {/* {goodsFilteredIsEmpty && <S.EmptyBlock>По вашему запросу ничего не найдено</S.EmptyBlock>}*/}
            {goods}
        </S.Container>
    )
}
CatalogGoodContainer.propTypes = {
    // eslint-disable-next-line react/require-default-props
    isDelivery: PropTypes.bool,
    // eslint-disable-next-line react/require-default-props
    groupId: PropTypes.number
}

export default CatalogGoodContainer
